import api from '../index'

let header = {}
export default {
    //用户登录
    login(params) {
        // return出去了一个promise
        return api.post('/oauth/token', params, {
            ...header,
            post: { 'Content-Type': 'multipart/form-data' }
        })
    },
    // 获取凭证
    getVi(params) {
        return api.get('/oauth/client', params, {
            ...header,
            service: 'main'
        })
    },
    // 获取凭证（新）
    getNewVi(params) {
        return api.get('/oauth/v2/client', params, {
            ...header,
            service: 'main'
        })
    },
    
    //获取登录二维码
    getQRCode(params){
        return api.get(`/oauth/getQrCodeImg`, params, header)
    },

    //获取登录状态
    getStatus(params){
        return api.get(`/oauth/selectQrCodeStatus`, params, header)
    }
}
